export interface PipelinePageProps {
    // Props passed from Blazor (currently none needed)
}

export const PipelineComponent = {
    MountAsync: async (target: HTMLElement, props: PipelinePageProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { PipelinePage } = await import('./PipelinePage');
        return await mountReactComponentAsync(target, PipelinePage, props);
    }
};
